var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCardHelp01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_5077",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 4,
    width: 6,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6318 4H43.895V22.5086H38.6318V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_5077)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8424 22.5088C42.2613 22.5088 41.7897 22.0175 41.7897 21.4123V8.38596C41.7897 7.17763 40.8466 6.19298 39.6845 6.19298C39.1034 6.19298 38.6318 5.70175 38.6318 5.09649C38.6318 4.49123 39.1034 4 39.6845 4C42.0066 4 43.895 5.96711 43.895 8.38596V21.4123C43.895 22.0175 43.4234 22.5088 42.8424 22.5088",
    fill: "#00CCEA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5263 45.6668C35.9452 45.6668 35.4736 45.1756 35.4736 44.5703V35.7984C35.4736 35.1931 35.9452 34.7019 36.5263 34.7019H39.6842C40.8463 34.7019 41.7894 33.7194 41.7894 32.5089V21.4124C41.7894 20.8071 42.261 20.3159 42.8421 20.3159C43.4231 20.3159 43.8947 20.8071 43.8947 21.4124V32.5089C43.8947 34.9278 42.0063 36.8949 39.6842 36.8949H37.5789V44.5703C37.5789 45.1756 37.1073 45.6668 36.5263 45.6668",
    fill: "#F5B6CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5262 45.6666C36.2567 45.6666 35.9872 45.5591 35.7809 45.3464L27.6693 36.8946H15.4735C14.8925 36.8946 14.4209 36.4034 14.4209 35.7982C14.4209 35.1929 14.8925 34.7017 15.4735 34.7017H28.1051C28.3851 34.7017 28.6525 34.8179 28.8504 35.0218L37.2714 43.7938C37.682 44.2236 37.682 44.9166 37.2714 45.3464C37.0651 45.5591 36.7956 45.6666 36.5262 45.6666",
    fill: "#00C389"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4737 36.8946H10.2105C7.88842 36.8946 6 34.9275 6 32.5087V17.0482C6 16.4429 6.47158 15.9517 7.05263 15.9517C7.63368 15.9517 8.10526 16.4429 8.10526 17.0482V32.5087C8.10526 33.7192 9.05053 34.7017 10.2105 34.7017H15.4737C16.0547 34.7017 16.5263 35.1929 16.5263 35.7982C16.5263 36.4034 16.0547 36.8946 15.4737 36.8946",
    fill: "#FDDA24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05263 18.1452C6.47158 18.1452 6 17.654 6 17.0487V8.38645C6 5.96759 7.88842 4.00049 10.2105 4.00049H39.6842C40.2653 4.00049 40.7368 4.48952 40.7368 5.09698C40.7368 5.70224 40.2653 6.19347 39.6842 6.19347H10.2105C9.05053 6.19347 8.10526 7.17812 8.10526 8.38645V17.0487C8.10526 17.654 7.63368 18.1452 7.05263 18.1452",
    fill: "#9063CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9476 28.1228C24.3666 28.1228 23.895 27.6316 23.895 27.0263V25.9956C23.895 23.8531 25.0171 21.9539 26.7518 21.1535C28.6066 20.2456 29.5518 18.114 29.0234 15.9846C28.6613 14.5416 27.4824 13.3136 26.0908 12.9342C24.7708 12.5767 23.4087 12.8552 22.3645 13.6995C21.3308 14.5351 20.7371 15.7938 20.7371 17.1579C20.7371 17.7631 20.2655 18.2544 19.6845 18.2544C19.1034 18.2544 18.6318 17.7631 18.6318 17.1579C18.6318 15.1118 19.5224 13.2193 21.0739 11.9649C22.6339 10.7061 24.6529 10.2851 26.6192 10.8092C28.7624 11.3947 30.5034 13.2083 31.0592 15.432C31.8445 18.6009 30.4318 21.7719 27.6255 23.1491C26.6297 23.6074 26.0003 24.7215 26.0003 25.9956V27.0263C26.0003 27.6316 25.5287 28.1228 24.9476 28.1228M24.9897 32.5088C24.4087 32.5088 23.9266 32.0175 23.9266 31.4123C23.9266 30.807 24.3876 30.3158 24.9687 30.3158H24.9897C25.5708 30.3158 26.0424 30.807 26.0424 31.4123C26.0424 32.0175 25.5708 32.5088 24.9897 32.5088",
    fill: "#FF7F37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardHelp01);
export default __webpack_public_path__ + "static/media/icon_card_help_01.424a16321dc415c4cddb4fa761f8d003.svg";
export { ForwardRef as ReactComponent };